// extracted by mini-css-extract-plugin
module.exports = {"green":"buttonBuehler-module--green--25QzQ","white":"buttonBuehler-module--white--2caA7"};